// extracted by mini-css-extract-plugin
export var bgLoading = "index-module--bg-loading--75d14";
export var borderLoading = "index-module--border-loading--dee18";
export var breakBorderLoading = "index-module--break-border-loading--3d4db";
export var gradient = "index-module--gradient--5479b";